<template>
  <section class="section" :id="id" :class="[`section--${type}`]" :style="{'max-height': maxHeight ? (maxHeight + 'px') : 'auto'}">
    <slot></slot>
  </section>
</template>

<script>
  export default {
    props: {
      type: {
        type: [String], // Enum: light, dark, yellow
        default: 'light'
      },
      maxHeight: {
        type: [String, Number],
      },
      id: {
        type: String,
        default: '',
      }
    }
  }
</script>

<style lang="scss" scoped>
  .section {
    padding: 110px 20px 90px;
    max-height: 2000px;
    transition: max-height ease 1.3s;

    &--yellow {
      background: linear-gradient(-135deg, #fcfcf8 0%, #efefe1 100%);
    }

    &--dark {
      color: #fff !important;
      background: #183E55;
    }
  }
</style>
